module.exports = function() { return __webpack_public_path__ + "when-traveling@2x.gWOS3-hT4O8EeI9Ddszy.png";};